<dx-select-box #selectBox
    [dataSource]="keys"
    displayExpr="name"
    valueExpr="id"
    [disabled]="isDisabled"
    [showClearButton]="true"
    (selectedItemChange)="onSelectedItemChange($event)">
    <dx-validator>
        <dxi-validation-rule *ngIf="isRequired" type="required" [message]="'_pickers.msgPgpKeyRequired' | translate"></dxi-validation-rule>
    </dx-validator>
</dx-select-box>
